// extracted by mini-css-extract-plugin
export default {"ConfirmationPop":"IngredientsPop_ConfirmationPop__4zD9A","modalBody":"IngredientsPop_modalBody__kC+Wi"};